import { render, staticRenderFns } from "./plmQuickChange.vue?vue&type=template&id=e5732124&scoped=true"
import script from "./plmQuickChange.vue?vue&type=script&lang=js"
export * from "./plmQuickChange.vue?vue&type=script&lang=js"
import style0 from "./plmQuickChange.vue?vue&type=style&index=0&id=e5732124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5732124",
  null
  
)

export default component.exports